import { SUPPORTED_REWARD_TYPE_TAGS } from '../../../lib/constants';
import { filterTags } from '../../../lib/eventUtils';
import { mapTagToLoyaltyCurrency } from '../../../lib/listingUtils';
import { LoyaltyCurrencies, LoyaltyCurrency } from '../../../modules/partnership';
import { REWARD_TAGS_ID_MAP } from '../RewardsSwitcher';

// Utility function to find the first matching LoyaltyCurrency from a list of tags
export const findFirstMatchingCurrency = (
  tags: string[],
  loyaltyCurrencies: LoyaltyCurrencies | undefined,
): LoyaltyCurrency | undefined => {
  return tags
    .map((tag) => mapTagToLoyaltyCurrency(tag, loyaltyCurrencies))
    .find((currency) => currency !== undefined);
};

export const getDisplayLoyaltyCurrency = (params: {
  selectedLoyaltyCurrency: LoyaltyCurrency,
  tags: string[] | undefined,
}): LoyaltyCurrency | undefined => {
  const { selectedLoyaltyCurrency, tags: listingTags } = params;  
  // IF Listings does not has any tags means that it can be displayed to any rewards
  if (!listingTags || !listingTags.length) {
    return selectedLoyaltyCurrency;
  }

  const supportedRewardTags = filterTags({ tags: listingTags, supportedTags: SUPPORTED_REWARD_TYPE_TAGS });

  // IF Listings does not has any SUPPORTED_REWARD_TYPE_TAGS means that it can be displayed to any rewards.
  if (!supportedRewardTags.length) {
    return selectedLoyaltyCurrency;
  }

  // Step 1: Find the RewardTag that corresponds to selectedCurrency.id
  const matchingRewardTag = Object.keys(REWARD_TAGS_ID_MAP).find(
    (rewardTag) => REWARD_TAGS_ID_MAP[rewardTag] === selectedLoyaltyCurrency.id,
  );

  if (!matchingRewardTag) {
    // If no RewardTag matches the selectedCurrency.id, return undefined
    return undefined;
  }

  // Step 2: Check if the matchingRewardTag exists in the rewardTags array
  const hasMatchingTag = supportedRewardTags.includes(matchingRewardTag);

  // Step 3: Return the selectedCurrency if a match is found; otherwise, undefined
  return hasMatchingTag ? selectedLoyaltyCurrency : undefined;
};
